import React from 'react';
import _ from 'lodash';

import StatusBox from 'components/StatusBox';
import {KYC_SECTION_STATUSES} from 'ducks/bookings';

const KycSectionStatusBox = ({status}: {status: string}) => {
  return (
    <StatusBox
      color={_.get(KYC_SECTION_STATUSES, `[${status}].color`)}
      status={_.get(KYC_SECTION_STATUSES, `[${status}].label`)}
    />
  );
};

export default KycSectionStatusBox;
